import { jsx as e } from "react/jsx-runtime";
import { ProfileLuminous as i } from "./themes/luminous/index.mjs";
import { ProfileDefault as m } from "./themes/default/index.mjs";
import { ProfileCamilla as a } from "./themes/camilla/index.mjs";
import { ProfileNight as f } from "./themes/night/index.mjs";
import { ProfileCreamy as n } from "./themes/creamy/index.mjs";
import { ProfileSepia as l } from "./themes/sepia/index.mjs";
import { ProfileSolarized as u } from "./themes/solarized/index.mjs";
import { ProfileNewYork as c } from "./themes/new-york/index.mjs";
import { ProfileUrban as s } from "./themes/urban/index.mjs";
import { ProfileCyberpunk as P } from "./themes/cyberpunk/index.mjs";
import { ProfileCosmopolitan as h } from "./themes/cosmopolitan/index.mjs";
import { StoreThemeEnum as o } from "../themes/enums/store-theme-enum.mjs";
import { useDesignContext as y } from "../providers/use-design-provider.mjs";
const L = (r) => {
  const {
    state: { theme: t }
  } = y();
  switch (t) {
    case o.luminous:
      return /* @__PURE__ */ e(i, { ...r });
    case o.camilla:
      return /* @__PURE__ */ e(a, { ...r });
    case o.night:
      return /* @__PURE__ */ e(f, { ...r });
    case o.creamy:
      return /* @__PURE__ */ e(n, { ...r });
    case o.sepia:
      return /* @__PURE__ */ e(l, { ...r });
    case o.solarized:
      return /* @__PURE__ */ e(u, { ...r });
    case o.new_york:
      return /* @__PURE__ */ e(c, { ...r });
    case o.urban:
      return /* @__PURE__ */ e(s, { ...r });
    case o.cyberpunk:
      return /* @__PURE__ */ e(P, { ...r });
    case o.cosmopolitan:
      return /* @__PURE__ */ e(h, { ...r });
    case o.default:
    default:
      return /* @__PURE__ */ e(m, { ...r });
  }
};
export {
  L as Profile
};
